let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8XKch")).then(() => parcelRequire('cG0zi'));